import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Coa.css";
import { CREATE_COA_RESET } from "../redux/constants/productConstant";
import { clearError, createCoa } from "../redux/actions/productAction";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import Header from "../Components/Header";

const CreateCoaPage = () => {
  var companyDetailsStr = localStorage.getItem("company");
  const type = localStorage.getItem("type");
  const createMember = localStorage.getItem("createMember");
  const [createBy, setCreateBy] = useState("");
  const [createByNew, setCreateByNew] = useState("");
  // if (!companyDetailsStr) {
  // console.log(type)
  var companyDetails = JSON.parse(companyDetailsStr);
  // }

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { product, productId } = useSelector((state) => state.select);
  const {
    error,
    loading,
    success,
    coaId: COAID,
  } = useSelector((state) => state.createCoa);

  useEffect(() => {
    if (error) {
      alert(error);
      dispatch(clearError());
    }

    if (success) {
      alert("Document Created Successful");
      navigate(`/coa/${COAID}`);
      dispatch({ type: CREATE_COA_RESET });
    }
  }, [error, success]);

  // console.log(product && product)

  // ----------------------------------------------
  const [coa, setCoa] = useState({
    // product ---------------------------

    NAME: "",
    EXPIRY_DATE: "",
    MANUFACTURING_DATE: "",
    COA_DATE: "",
    // company ---------------------------

    CIN: "",
    GST: "",
    address: "",
    email: "",
    img: "",
    companyName: "",
    phone: "",
    title: "",
    website: "",
  });

  const submitHandle = (e) => {
    e.preventDefault();
    // console.log(items, items2)

    console.log(topFV);
    //
    dispatch(
      createCoa({
        ...coa,
        productId: productId,
        type,
        Status: "created",
        NAME: coa?.NAME,
        name: coa.companyName,
        items1: items,
        items2,
        items3,
        createBy,
        createByNew,
        topFV,
        remark,
        itemsGc,
        headingGc,
      })
    );
  };
  const handleOnChange = (e) => {
    setCoa({ ...coa, [e.target.name]: e.target.value });
  };

  //  items and items2 varialbe define ------------------------------------------------------

  const [items, setItems] = useState([]);
  const [name, setName] = useState("");
  const [value, setValue] = useState("");
  const [editItemId, setEditItemId] = useState(null);

  const [itemsGc, setItemsGc] = useState([]);
  const [headingGc, setHeadingGc] = useState("");
  const [nameGc, setNameGc] = useState("");
  const [valueGc, setValueGc] = useState("");
  const [valueGc2, setValueGc2] = useState("");
  const [editItemIdGc, setEditItemIdGc] = useState(null);

  const [items2, setItems2] = useState([]);
  const [_name, _setName] = useState("");
  const [_value1, _setValue1] = useState("");
  const [_value2, _setValue2] = useState("");
  const [editItemId2, setEditItemId2] = useState(null);

  const [items3, setItems3] = useState([]);
  const [name3, setName3] = useState("");
  const [value3, setValue3] = useState("");
  const [editItemId3, setEditItemId3] = useState(null);

  const [topFV, setTopFV] = useState([]);
  const [name1, setName1] = useState("");
  const [value1, setValue1] = useState("");
  const [name2, setName2] = useState("");
  const [value2, setValue2] = useState("");
  const [editItemIdFV, setEditItemIdFV] = useState(null);

  const [remark, setRemark] = useState("");
  const [isRemark, setIsRemark] = useState(false);

  //  items and items2 varialbe define end ------------------------------------------------------

  useEffect(() => {
    // --------------------
    setCoa({
      ...coa,
      // companyName: product?.name ? product.name : companyDetails?.name,
      // CIN: product?.CIN ? product.CIN : companyDetails?.CIN,
      // title: product?.title ? product.title : companyDetails?.title,
      // website: product?.website ? product.website : companyDetails?.website,
      // phone: product?.phone ? product.phone : companyDetails?.phone,
      // address: product?.address ? product.address : companyDetails?.address,
      // email: product?.email ? product.email : companyDetails?.email,
      // GST: product?.GST ? product.GST : companyDetails?.GST,
      // img: product?.img ? product.img : companyDetails?.img,

      companyName: companyDetails?.name,
      CIN: companyDetails?.CIN,
      title: companyDetails?.title,
      website: companyDetails?.website,
      phone: companyDetails?.phone,
      address: companyDetails?.address,
      email: companyDetails?.email,
      GST: companyDetails?.GST,
      img: companyDetails?.img,

      // product ---------------------------

      NAME: product?.NAME,
      EXPIRY_DATE: "",
      MANUFACTURING_DATE: "",
      COA_DATE: "",
    });

    if (product?.items1 && product?.items1.length !== 0) {
      // console.log('set items')
      setItems(product?.items1);
    }
    if (product?.items2 && product?.items2.length !== 0) {
      // console.log('set items')
      setItems2(product?.items2);
    }
    console.log("product...", product?.itemsGc);

    if (product?.itemsGc && product?.itemsGc?.length > 0) {
      setItemsGc(product?.itemsGc);
      setHeadingGc(product?.headingGc);
    }
    if (product?.items3 && product?.items3.length !== 0) {
      // console.log('set items')
      setItems3(product?.items3);
    }
    if (product?.topFV && product?.topFV.length !== 0) {
      // console.log('set items')
      console.log(product.topFV);
      setTopFV(product?.topFV);
    }

    setRemark(product?.remark);
    // setCoaData()
  }, [product]);

  // console.log(items, items2)

  // items1  code ---------------------------------------------------

  const addItem = (e) => {
    e.preventDefault();

    if (name && value) {
      const newItem = {
        id: uuidv4(),
        name,
        value,
      };
      setItems([...items, newItem]);
      setName("");
      setValue("");
    }
  };

  const updateItem = (e, id) => {
    e.preventDefault();

    if (updateName && updateValue) {
      const updatedItems = items.map((item) =>
        item.id === id
          ? { ...item, name: updateName, value: updateValue }
          : item
      );
      setItems(updatedItems);
      setEditItemId(null);
    }
  };

  const deleteItem = (id) => {
    const newItems = items.filter((item) => item.id !== id);
    setItems(newItems);
  };

  const [updateName, setUpdateName] = useState("");
  const [updateValue, setUpdateValue] = useState("");

  const editItem = (e, id) => {
    e.preventDefault();
    // alert(e, id)
    const itemToEdit = items.find((item) => item.id === id);

    if (itemToEdit) {
      setUpdateName(itemToEdit.name);
      setUpdateValue(itemToEdit.value);
      setEditItemId(id);
    }
  };

  // items2 code ---------------------------------------------------

  // items GC  code ---------------------------------------------------

  const addItemGc = (e) => {
    e.preventDefault();

    if (nameGc && valueGc) {
      const newItem = {
        id: uuidv4(),
        nameGc,
        valueGc,
        valueGc2,
      };
      setItemsGc([...itemsGc, newItem]);
      setNameGc("");
      setValueGc("");
      setValueGc2("");
    }
  };

  const updateItemGc = (e, id) => {
    e.preventDefault();

    if (updateNameGc && updateValueGc) {
      const updatedItems = itemsGc.map((item) =>
        item.id === id
          ? {
              ...item,
              nameGc: updateNameGc,
              valueGc: updateValueGc,
              valueGc2: updateValueGc2,
            }
          : item
      );
      setItemsGc(updatedItems);
      setEditItemIdGc(null);
    }
  };

  const deleteItemGc = (id) => {
    const newItems = itemsGc.filter((item) => item.id !== id);
    setItemsGc(newItems);
  };

  const [updateNameGc, setUpdateNameGc] = useState("");
  const [updateValueGc, setUpdateValueGc] = useState("");
  const [updateValueGc2, setUpdateValueGc2] = useState("");

  const editItemGc = (e, id) => {
    e.preventDefault();
    // alert(e, id)
    const itemToEdit = itemsGc.find((item) => item.id === id);

    if (itemToEdit) {
      setUpdateNameGc(itemToEdit.nameGc);
      setUpdateValueGc(itemToEdit.valueGc);
      setUpdateValueGc2(itemToEdit.valueGc2);
      setEditItemIdGc(id);
    }
  };

  // items GC code ---------------------------------------------------

  const addItem2 = (e) => {
    e.preventDefault();

    if (_name && _value1) {
      const newItem = {
        id: uuidv4(),
        _name,
        _value1,
        _value2,
      };

      setItems2([...items2, newItem]);
      _setName("");
      _setValue1("");
      _setValue2("");
    }
  };

  const [_updateName, _setUpdateName] = useState("");
  const [_updateValue1, _setUpdateValue1] = useState("");
  const [_updateValue2, _setUpdateValue2] = useState("");

  const updateItem2 = (e, id) => {
    e.preventDefault(_updateName, _updateValue1, _updateValue2);

    if (_updateName && _updateValue1) {
      console.log(editItemId2 === id);
      const updatedItems = items2.map((item) =>
        item.id === id
          ? {
              ...item,
              _name: _updateName,
              _value1: _updateValue1,
              _value2: _updateValue2,
            }
          : item
      );

      setItems2(updatedItems);
      setEditItemId2(null);
    }
  };

  const deleteItem2 = (id) => {
    const newItems = items2.filter((item) => item.id !== id);
    setItems2(newItems);
  };

  const editItem2 = (e, id) => {
    e.preventDefault();
    // alert(e, id)
    const itemToEdit = items2.find((item) => item.id === id);

    if (itemToEdit) {
      _setUpdateName(itemToEdit._name);
      _setUpdateValue1(itemToEdit._value1);
      _setUpdateValue2(itemToEdit._value2);

      setEditItemId2(id);
    }
  };

  const cancelHandle2 = (e) => {
    e.preventDefault();
    setEditItemId2(null);
  };

  // console.log(items, items2)

  useEffect(() => {
    if (createMember === "newMember") {
      setCreateBy(createMember);
      setCreateByNew("newMember");
    } else {
      setCreateBy(createMember);
    }
  }, [createMember]);

  // ------------------------------ Top Filed value  code ---------------------------------------------------
  const [updateName1, setUpdateName1] = useState("");
  const [updateValue1, setUpdateValue1] = useState("");
  const [updateName2, setUpdateName2] = useState("");
  const [updateValue2, setUpdateValue2] = useState("");

  const addItemFV = (e) => {
    e.preventDefault();
    console.log("addtiem");

    if (name1 && value1) {
      const newItem = {
        id: uuidv4(),
        name1,
        value1,
        name2,
        value2,
      };
      setTopFV([...topFV, newItem]);
      setName1("");
      setValue1("");
      setName2("");
      setValue2("");
    }
  };

  const updateItemFV = (e, id) => {
    e.preventDefault();

    if (updateName1 && updateValue1) {
      const updatedItems = topFV.map((item) =>
        item.id === id
          ? {
              ...item,
              name1: updateName1,
              value1: updateValue1,
              name2: updateName2,
              value2: updateValue2,
            }
          : item
      );
      setTopFV(updatedItems);
      setEditItemIdFV(null);
    }
  };

  const deleteItemFV = (id) => {
    const newItems = topFV.filter((item) => item.id !== id);
    setTopFV(newItems);
  };

  const editItemFV = (e, id) => {
    e.preventDefault();
    // alert(e, id)
    const itemToEdit = topFV.find((item) => item.id === id);

    if (itemToEdit) {
      setUpdateName1(itemToEdit.name1);
      setUpdateValue1(itemToEdit.value1);
      setUpdateName2(itemToEdit.name2);
      setUpdateValue2(itemToEdit.value2);
      setEditItemIdFV(id);
    }
  };

  const isRemarkHandle = () => {
    setIsRemark(!isRemark);

    // if(i)
    setRemark("");
  };

  return (
    <>
      <Header />
      <div className="CoaContainer topSpace">
        <form action="" className="coaForm" onSubmit={(e) => submitHandle(e)}>
          <h4>CREATE YOUR {type.toUpperCase()}</h4>
          <div className="coaFormBox">
            <p>Company Details</p>
            <div className="inpBox">
              <div className="cinputBox">
                <p>Company Name</p>
                <input
                  type="text"
                  required
                  name="companyName"
                  placeholder="Enter"
                  id="1"
                  value={coa.companyName}
                  className="cinput"
                  onChange={handleOnChange}
                />
              </div>
              <div className="cinputBox">
                <p>Company Title</p>
                <input
                  type="text"
                  name="title"
                  placeholder="Enter"
                  id="2"
                  className="cinput"
                  value={coa?.title}
                  onChange={handleOnChange}
                />
              </div>
              <div className="cinputBox">
                <p>CIN</p>

                <input
                  type="text"
                  name="CIN"
                  placeholder="Enter"
                  id="3"
                  className="cinput"
                  value={coa?.CIN}
                  onChange={handleOnChange}
                />
              </div>
            </div>
            <div className="inpBox">
              <div className="cinputBox">
                <p>Address</p>
                <input
                  type="text"
                  name="Address"
                  placeholder="Enter"
                  id="4"
                  className="cinput"
                  value={coa?.address}
                  onChange={handleOnChange}
                />
              </div>
              <div className="cinputBox">
                <p>Email</p>
                <input
                  type="text"
                  name="Email"
                  placeholder="Enter"
                  id="5"
                  className="cinput"
                  value={coa?.email}
                  onChange={handleOnChange}
                />
              </div>
              <div className="cinputBox">
                <p>Phone</p>
                <input
                  type="text"
                  name="Phone"
                  placeholder="Enter"
                  id="6"
                  className="cinput"
                  value={coa?.phone}
                  onChange={handleOnChange}
                />
              </div>
            </div>

            <div className="inpBox">
              <div className="cinputBox">
                <p>Website</p>
                <input
                  type="text"
                  name="website"
                  placeholder="Enter"
                  id="7"
                  className="cinput"
                  value={coa?.website}
                  onChange={handleOnChange}
                />
              </div>
              <div className="cinputBox">
                <p>GST</p>
                <input
                  type="text"
                  name="GST"
                  placeholder="Enter"
                  id="8"
                  className="cinput"
                  value={coa?.GST}
                  onChange={handleOnChange}
                />
              </div>
            </div>
            {/* <hr /> */}
            <p>Product Details</p>
            <div className="inpBox">
              <div className="cinputBox">
                <p>Product Name</p>
                <input
                  type="text"
                  required
                  name="NAME"
                  placeholder="Enter"
                  id="8"
                  className="cinput"
                  value={coa?.NAME}
                  onChange={handleOnChange}
                />
              </div>
            </div>

            {
              // --------------------------------------------- dates -------------------------------------------------
              type.toUpperCase() !== "SPEC" && (
                <div className="inpBox">
                  <div className="cinputBox">
                    <p>COA DATE</p>
                    <input
                      type="date"
                      name="COA_DATE"
                      placeholder="Enter"
                      id="8"
                      className="cinput"
                      value={coa?.COA_DATE}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="cinputBox">
                    <p>MANUFACTURING DATE</p>
                    <input
                      type="date"
                      name="MANUFACTURING_DATE"
                      placeholder="Enter"
                      id="8"
                      className="cinput"
                      value={coa?.MANUFACTURING_DATE}
                      onChange={handleOnChange}
                    />
                  </div>

                  <div className="cinputBox">
                    <p>EXPIRY DATE</p>
                    <input
                      type="date"
                      name="EXPIRY_DATE"
                      placeholder="Enter"
                      id="8"
                      className="cinput"
                      value={coa?.EXPIRY_DATE}
                      onChange={handleOnChange}
                    />
                  </div>
                </div>
              )
            }

            {/* -------------------------------------------------------------------------------------------------------------- */}
            {/* Custom Fields-Value code */}

            <p>Custom Top Fields-Value</p>
            <div className="customContainer">
              <div className="customInputBox">
                <input
                  className="input1"
                  type="text"
                  placeholder="Name"
                  value={name1}
                  onChange={(e) => setName1(e.target.value)}
                />
                <input
                  className="input2"
                  type="text"
                  placeholder="Value"
                  value={value1}
                  onChange={(e) => setValue1(e.target.value)}
                />
                <input
                  className="input1"
                  type="text"
                  placeholder="Name"
                  value={name2}
                  onChange={(e) => setName2(e.target.value)}
                />
                <input
                  className="input2"
                  type="text"
                  placeholder="Value"
                  value={value2}
                  onChange={(e) => setValue2(e.target.value)}
                />

                <button
                  className="addBtn"
                  onClick={addItemFV}
                  onKeyDown={addItemFV}
                >
                  Add
                </button>
              </div>

              <div className="itemsViewBox">
                {topFV.map((item) => (
                  <div key={item.id} className="itemsView">
                    <input
                      className={
                        editItemIdFV === item.id ? "field1Edit" : "field1"
                      }
                      type="text"
                      value={
                        editItemIdFV === item.id ? updateName1 : item.name1
                      }
                      onChange={(e) => setUpdateName1(e.target.value)}
                      disabled={editItemIdFV !== item.id}
                    />
                    <input
                      className={
                        editItemIdFV === item.id ? "field1Edit" : "field1"
                      }
                      type="text"
                      value={
                        editItemIdFV === item.id ? updateValue1 : item.value1
                      }
                      onChange={(e) => setUpdateValue1(e.target.value)}
                      disabled={editItemIdFV !== item.id}
                    />
                    <input
                      className={
                        editItemIdFV === item.id ? "field1Edit" : "field1"
                      }
                      type="text"
                      value={
                        editItemIdFV === item.id ? updateName2 : item.name2
                      }
                      onChange={(e) => setUpdateName2(e.target.value)}
                      disabled={editItemIdFV !== item.id}
                    />
                    <input
                      className={
                        editItemIdFV === item.id ? "field1Edit" : "field1"
                      }
                      type="text"
                      value={
                        editItemIdFV === item.id ? updateValue2 : item.value2
                      }
                      onChange={(e) => setUpdateValue2(e.target.value)}
                      disabled={editItemIdFV !== item.id}
                    />
                    {editItemIdFV === item.id ? (
                      <>
                        <button
                          className="addBtn"
                          onClick={(e) => updateItemFV(e, item.id)}
                        >
                          Save
                        </button>
                        <button
                          className="del-Btn"
                          onClick={(e) => {
                            e.preventDefault();
                            setEditItemIdFV(null);
                          }}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="addBtn"
                          onClick={(e) => editItemFV(e, item.id)}
                        >
                          Edit
                        </button>
                        <button
                          className="del-Btn"
                          onClick={(e) => {
                            e.preventDefault();
                            deleteItemFV(item.id);
                          }}
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* --------------------------------------------------------------------------------------------------------- */}
            {/* Custom items 1 code */}

            <p>Custom Fields with 1 value</p>
            <div className="customContainer">
              <div className="customInputBox">
                <input
                  className="input1"
                  type="text"
                  placeholder="Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                <input
                  className="input2"
                  type="text"
                  placeholder="Value"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                />

                <button
                  className="addBtn"
                  onClick={addItem}
                  onKeyDown={addItem}
                >
                  Add
                </button>
              </div>

              <div className="itemsViewBox">
                {items.map((item) => (
                  <div key={item.id} className="itemsView">
                    <input
                      className={
                        editItemId === item.id ? "field1Edit" : "field1"
                      }
                      type="text"
                      value={editItemId === item.id ? updateName : item.name}
                      onChange={(e) => setUpdateName(e.target.value)}
                      disabled={editItemId !== item.id}
                    />
                    <input
                      className={
                        editItemId === item.id ? "field1Edit" : "field1"
                      }
                      type="text"
                      value={editItemId === item.id ? updateValue : item.value}
                      onChange={(e) => setUpdateValue(e.target.value)}
                      disabled={editItemId !== item.id}
                    />
                    {editItemId === item.id ? (
                      <>
                        <button
                          className="addBtn"
                          onClick={(e) => updateItem(e, item.id)}
                        >
                          Save
                        </button>
                        <button
                          className="del-Btn"
                          onClick={(e) => {
                            e.preventDefault();
                            setEditItemId(null);
                          }}
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="addBtn"
                          onClick={(e) => editItem(e, item.id)}
                        >
                          Edit
                        </button>
                        <button
                          className="del-Btn"
                          onClick={() => deleteItem(item.id)}
                        >
                          Delete
                        </button>
                      </>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Custom items 2 code */}
            {/* { */}
            {/* type !== "spec" && */}
            <>
              <p>Custom Fields with 2 values</p>
              <div className="customContainer">
                <div className="customInputBox">
                  <input
                    className={type !== "spec" ? "input3" : "input1"}
                    type="text"
                    placeholder="Name"
                    value={_name}
                    onChange={(e) => _setName(e.target.value)}
                  />
                  <input
                    className={type !== "spec" ? "input3" : "input1"}
                    type="text"
                    placeholder="Value 1 "
                    value={_value1}
                    onChange={(e) => _setValue1(e.target.value)}
                  />
                  {type !== "spec" && (
                    <input
                      type="text"
                      className="input3"
                      placeholder="Value 2 "
                      value={_value2}
                      onChange={(e) => _setValue2(e.target.value)}
                    />
                  )}

                  <button
                    className="addBtn"
                    onClick={addItem2}
                    onKeyDown={addItem2}
                  >
                    {"Add "}
                  </button>
                </div>

                <div className="itemsViewBox">
                  {items2.map((item) => (
                    <div key={item.id} className="itemsView">
                      <input
                        className={
                          editItemId2 === item.id
                            ? type !== "spec"
                              ? "name1Edit"
                              : "field1"
                            : type !== "spec"
                            ? "name1"
                            : "field1"
                        }
                        type="text"
                        value={
                          editItemId2 === item.id ? _updateName : item._name
                        }
                        onChange={(e) => _setUpdateName(e.target.value)}
                        disabled={editItemId2 !== item.id}
                      />
                      <input
                        className={
                          editItemId2 === item.id
                            ? type !== "spec"
                              ? "name1Edit"
                              : "field1"
                            : type !== "spec"
                            ? "name1"
                            : "field1"
                        }
                        type="text"
                        value={
                          editItemId2 === item.id ? _updateValue1 : item._value1
                        }
                        onChange={(e) => _setUpdateValue1(e.target.value)}
                        disabled={editItemId2 !== item.id}
                      />
                      {type !== "spec" && (
                        <input
                          className={
                            editItemId2 === item.id ? "name1Edit" : "name1"
                          }
                          type="text"
                          value={
                            editItemId2 === item.id
                              ? _updateValue2
                              : item._value2
                          }
                          onChange={(e) => _setUpdateValue2(e.target.value)}
                          disabled={editItemId2 !== item.id}
                        />
                      )}
                      {editItemId2 === item.id ? (
                        <>
                          <button
                            className="addBtn"
                            onClick={(e) => updateItem2(e, item.id)}
                          >
                            Save
                          </button>
                          <button
                            className="del-Btn"
                            onClick={(e) => {
                              e.preventDefault();
                              cancelHandle2(e);
                            }}
                          >
                            Cancel
                          </button>
                        </>
                      ) : (
                        <>
                          <button
                            className="addBtn"
                            onClick={(e) => editItem2(e, item.id)}
                          >
                            Edit
                          </button>
                          <button
                            className="del-Btn"
                            onClick={() => deleteItem2(item.id)}
                          >
                            Delete
                          </button>
                        </>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </>

            {/* -------------------------------------- GC PROFILE -----------------------------------  */}
            {
              // type !== 'spec' &&
              <>
                <p>Custom Fields with 1 value (GC)</p>

                <div className="customContainer">
                  <div className="itemsViewGc1">
                    <input
                      type="text"
                      placeholder="Enter Heading"
                      className="input1"
                      value={headingGc}
                      onChange={(e) => setHeadingGc(e.target.value)}
                    />
                  </div>

                  <div className="customInputBox">
                    <input
                      className="input1"
                      type="text"
                      placeholder="Name"
                      value={nameGc}
                      onChange={(e) => setNameGc(e.target.value)}
                    />
                    <input
                      className="input2"
                      type="text"
                      placeholder="Value 1"
                      value={valueGc}
                      onChange={(e) => setValueGc(e.target.value)}
                    />

                    {type !== "spec" && (
                      <input
                        className="input2"
                        type="text"
                        placeholder="Value 2"
                        value={valueGc2}
                        onChange={(e) => setValueGc2(e.target.value)}
                      />
                    )}

                    <button className="addBtn" onClick={addItemGc}>
                      Add
                    </button>
                  </div>

                  <div className="itemsViewBox gcViews">
                    <div className="itemsViewGc">
                      {itemsGc.map((item) => (
                        <div key={item.id} className="itemsView">
                          <input
                            className={
                              editItemIdGc === item.id ? "field1Edit" : "field1"
                            }
                            type="text"
                            value={
                              editItemIdGc === item.id
                                ? updateNameGc
                                : item.nameGc
                            }
                            onChange={(e) => setUpdateNameGc(e.target.value)}
                            disabled={editItemIdGc !== item.id}
                          />
                          <input
                            className={
                              editItemIdGc === item.id ? "field1Edit" : "field1"
                            }
                            type="text"
                            value={
                              editItemIdGc === item.id
                                ? updateValueGc
                                : item.valueGc
                            }
                            onChange={(e) => setUpdateValueGc(e.target.value)}
                            disabled={editItemIdGc !== item.id}
                          />
                          {type !== "spec" && (
                            <input
                              className={
                                editItemIdGc === item.id
                                  ? "field1Edit"
                                  : "field1"
                              }
                              type="text"
                              value={
                                editItemIdGc === item.id
                                  ? updateValueGc2
                                  : item.valueGc2
                              }
                              onChange={(e) =>
                                setUpdateValueGc2(e.target.value)
                              }
                              disabled={editItemIdGc !== item.id}
                            />
                          )}
                          {editItemIdGc === item.id ? (
                            <>
                              <button
                                className="addBtn"
                                onClick={(e) => updateItemGc(e, item.id)}
                              >
                                Save
                              </button>
                              <button
                                className="del-Btn"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setEditItemIdGc(null);
                                }}
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <button
                                className="addBtn"
                                onClick={(e) => editItemGc(e, item.id)}
                              >
                                Edit
                              </button>
                              <button
                                className="del-Btn"
                                onClick={() => deleteItemGc(item.id)}
                              >
                                Delete
                              </button>
                            </>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </>
            }
            {/* -------------------------------------- GC PROFILE -----------------------------------  */}

            {/*  } */}

            {/* Custom items 3 code */}

            {/* {
              type === 'spec' &&
              <>
                <p>Custom Fields with 2 values </p>
                <div className='customContainer'>

                  <div className='customInputBox'>
                    <input
                      className='input1'
                      type="text"
                      placeholder="Name"
                      value={name3}
                      onChange={(e) => setName3(e.target.value)}
                    />
                    <input
                      className='input2'
                      type="text"
                      placeholder="Value"
                      value={value3}
                      onChange={(e) => setValue3(e.target.value)}
                    />

                    <button className='addBtn' onClick={addItem3}>Add</button>
                  </div>


                  <div className='itemsViewBox'>
                    {items3.map((item) => (
                      <div key={item.id} className='itemsView'>
                        <input
                          className={editItemId3 === item.id ? "field1Edit" : "field1"}
                          type="text"
                          value={editItemId3 === item.id ? updateName3 : item.name3}
                          onChange={(e) => setUpdateName3(e.target.value)}
                          disabled={editItemId3 !== item.id}
                        />
                        <input
                          className={editItemId3 === item.id ? "field1Edit" : "field1"}
                          type="text"
                          value={editItemId3 === item.id ? updateValue3 : item.value3}
                          onChange={(e) => setUpdateValue3(e.target.value)}
                          disabled={editItemId3 !== item.id}
                        />
                        {editItemId3 === item.id ? (
                          <>
                            <button className='addBtn' onClick={(e) => updateItem3(e, item.id)}>Save</button>
                            <button className='del-Btn' onClick={() => setEditItemId3(null)}>Cancel</button>
                          </>
                        ) : (
                          <>
                            <button className='addBtn' onClick={(e) => editItem3(e, item.id)}>Edit</button>
                            <button className='del-Btn' onClick={() => deleteItem3(item.id)}>Delete</button>
                          </>
                        )}
                      </div>
                    ))}
                  </div>

                </div>
              </>
            } */}

            <p>Check remark </p>
            <div className="remarkBox">
              <div>
                <input
                  type="checkbox"
                  name=""
                  id=""
                  value={isRemark}
                  onChange={isRemarkHandle}
                  className="checkBox"
                />
              </div>
              <div className="cinputBox">
                <p>Enter remark text</p>
                <input
                  type="text"
                  disabled={!isRemark}
                  required
                  placeholder="Enter Name"
                  className="cinput"
                  value={remark}
                  onChange={(e) => setRemark(e.target.value)}
                />
              </div>
            </div>

            <p>Document Created By</p>
            <div className="inpBox">
              <div className="cinputBox">
                <p>Created By </p>
                <input
                  type="text"
                  disabled={createMember !== "newMember"}
                  required
                  name="NAME "
                  placeholder="Enter Name"
                  id="8"
                  className="cinput"
                  value={createBy === "newMember" ? "" : createBy}
                  onChange={(e) => setCreateBy(e.target.value)}
                />
              </div>
            </div>

            <div className="submitBox">
              <input
                type="submit"
                name=""
                value={"Create Document"}
                id=""
                className="sinput"
              />
            </div>

            {/* iiiiiiii */}
          </div>
        </form>
      </div>
    </>
  );
};

export default CreateCoaPage;
